import Link from 'next/link';
import { Facebook, Instagram } from 'lucide-react';
import Logo from '@/components/logo';
import NewsletterSignup from '@/components/NewsletterSignup';

export default function Footer() {
  return (
    <footer className="bg-warm-white text-muted-foreground py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <NewsletterSignup variant="footer" tags={['placement-footer']} />
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start md:col-span-1">
            <Logo className="text-primary-foreground mb-3" />
            <p className="text-sm text-center md:text-left">Helping families recover from mold illness and reclaim their health.</p>
          </div>

          {/* Get Help */}
          <nav className="flex flex-col items-center md:items-start space-y-2">
            <p className="text-sm font-semibold text-foreground mb-1">Get Help</p>
            <Link href="/mold-assessment" className="text-sm hover:text-primary">Mold Symptoms Assessment</Link>
            <Link href="/mold-recovery-programs" className="text-sm hover:text-primary">Program</Link>
            <Link href="/faq" className="text-sm hover:text-primary">FAQ</Link>
            <Link href="/contact" className="text-sm hover:text-primary">Contact Us</Link>
          </nav>

          {/* Learn */}
          <nav className="flex flex-col items-center md:items-start space-y-2">
            <p className="text-sm font-semibold text-foreground mb-1">Learn</p>
            <Link href="/mold-illness-guides" className="text-sm hover:text-primary">Mold Illness Guides</Link>
            <Link href="/blog" className="text-sm hover:text-primary">Blog</Link>
            <Link href="/podcast" className="text-sm hover:text-primary">Podcast</Link>
            <Link href="/testimonials" className="text-sm hover:text-primary">Testimonials</Link>
            <Link href="/about" className="text-sm hover:text-primary">About Aubree</Link>
          </nav>

          {/* Legal + Social */}
          <div className="flex flex-col items-center md:items-start space-y-2">
            <p className="text-sm font-semibold text-foreground mb-1">Legal</p>
            <Link href="/terms-of-use" className="text-sm hover:text-primary">Terms of Use</Link>
            <Link href="/privacy-policy" className="text-sm hover:text-primary">Privacy Policy</Link>
            <Link href="/affiliate-disclosure" className="text-sm hover:text-primary">Affiliate Disclosure</Link>
            <div className="flex space-x-4 pt-3">
              <a href="https://www.facebook.com/profile.php?id=61586676996007" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-primary">
                <Facebook size={22} />
              </a>
              <a href="https://www.instagram.com/moldfreemom" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-primary">
                <Instagram size={22} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-6 text-center">
          <p className="text-sm">&copy; {new Date().getFullYear()} Mold Free Mom. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

// Placeholder pages for links in footer
export function TermsOfUsePage() {
  return <div className="container mx-auto py-8 px-4"><h1>Terms of Use</h1><p>Placeholder content for Terms of Use.</p></div>;
}

export function PrivacyPolicyPage() {
  return <div className="container mx-auto py-8 px-4"><h1>Privacy Policy</h1><p>Placeholder content for Privacy Policy.</p></div>;
}
